var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEscudo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 55.0033C26.3658 55.0033 23.7558 54.23 21.7017 52.7075L11.31 44.95C8.55501 42.8958 6.40417 38.5941 6.40417 35.1866V17.2066C6.40417 13.485 9.13501 9.52165 12.6392 8.21665L24.6983 3.69748C27.0908 2.80331 30.8608 2.80331 33.2533 3.69748L45.3125 8.21665C48.8167 9.52165 51.5475 13.485 51.5475 17.2066V35.1625C51.5475 38.5941 49.3967 42.8716 46.6417 44.9258L36.25 52.6833C34.2442 54.23 31.6342 55.0033 29 55.0033ZM25.9792 7.10498L13.92 11.6241C11.8658 12.3975 10.0533 15.0075 10.0533 17.2308V35.1866C10.0533 37.4825 11.6725 40.6966 13.485 42.05L23.8767 49.8075C26.6558 51.8858 31.3442 51.8858 34.1475 49.8075L44.5392 42.05C46.3758 40.6725 47.9708 37.4825 47.9708 35.1866V17.2066C47.9708 15.0075 46.1583 12.3975 44.1042 11.6L32.045 7.08081C30.4017 6.50081 27.5983 6.50081 25.9792 7.10498Z",
    fill: "url(#paint0_linear_1_1545)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7616 34.3892C25.3025 34.3892 24.8433 34.22 24.4808 33.8575L20.59 29.9667C19.8891 29.2658 19.8891 28.1058 20.59 27.405C21.2908 26.7042 22.4508 26.7042 23.1516 27.405L25.7616 30.015L34.8725 20.9042C35.5733 20.2033 36.7333 20.2033 37.4341 20.9042C38.135 21.605 38.135 22.765 37.4341 23.4658L27.0425 33.8575C26.68 34.22 26.2208 34.3892 25.7616 34.3892Z",
    fill: "url(#paint1_linear_1_1545)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1545",
    x1: 28.9758,
    y1: 3.02686,
    x2: 28.9758,
    y2: 55.0033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484C89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1545",
    x1: 29.012,
    y1: 20.3785,
    x2: 29.012,
    y2: 34.3892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484C89"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscudo);
export default __webpack_public_path__ + "static/media/escudo.976e2ba8365309ad87684a4678b17415.svg";
export { ForwardRef as ReactComponent };